import React, { useContext, useEffect, useState } from 'react';
import { InstantSearch } from 'react-instantsearch-hooks-web';
import TypesenseInstantSearchAdapter from 'typesense-instantsearch-adapter';
import { useQuery } from '@tanstack/react-query';

import Loading from './Loading';
import { getSearchConfig } from '../../lib/actions/search';
import { ApiContext, UserContext } from '../../App';

const rootConfig = {
  collectionSpecificSearchParameters: {
    companies: {
      query_by: 'name, dba, ein, phone',
    },

    orders: {
      query_by:
        'merchant_order_id, order_key, first_name, last_name, email, phone',
    },

    users: {
      query_by: 'company_name, company_id, email, first_name, last_name, phone',
    },

    credit_key_applications: {
      query_by:
        'company_name, company_id, dba, email, business_phone, ein, first_name, last_name, phone',
    },
  },
};

export default function SearchConfig({ children }) {
  const api = useContext(ApiContext);
  const user = useContext(UserContext);
  const [searchConfig, setSearchConfig] = useState();

  const { data, isLoading } = useQuery({
    queryKey: ['searchConfig', user?.id],
    queryFn: () => getSearchConfig(api),
    enabled: !searchConfig?.server?.apiKey,
    retry: false,
  });

  useEffect(() => {
    if (!isLoading && data) {
      setSearchConfig({
        ...rootConfig,
        server: {
          apiKey: data.key,
          nodes: data.nodes,
          cacheSearchResultsForSeconds: 120,
          randomizeNodes: true,
          sendApiKeyAsQueryParam: true,
        },
      });
    }
  }, [isLoading, data]);

  if (!searchConfig?.server?.apiKey) return <Loading className="w-14 h-14" />;

  const searchAdapter = new TypesenseInstantSearchAdapter(searchConfig);
  const searchClient = searchAdapter.searchClient;

  if (!searchClient) return null;

  return (
    <>
      <InstantSearch searchClient={searchClient} indexName="orders">
        {children}
      </InstantSearch>
    </>
  );
}
